<template>
    <div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" style="height: 490" v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="productId" label="产品ID"></el-table-column>
                <el-table-column prop="productName" label="产品名称"></el-table-column>
                <el-table-column label="长期订购" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-checkbox :checked="scope.row.s1!='0'"
                                     @change="saveOrUpdateRegularProduct($event,scope.row,1)">选择
                        </el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="小奶童" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-checkbox :checked="scope.row.s2!='0'"
                                     @change="saveOrUpdateRegularProduct($event,scope.row,2)">选择
                        </el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="小程序" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-checkbox :checked="scope.row.s4!='0'"
                                     @change="saveOrUpdateRegularProduct($event,scope.row,4)">选择
                        </el-checkbox>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        findAllProducts,
        saveOrUpdateRegularProduct,
    } from '../../api/api';


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                loading: true,
                form: {
                    regularProductId: '',
                    productId: '',
                    productName: '',
                    channelType: '',
                },
            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                findAllProducts().then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.dataList=[];
                        this.dataList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            saveOrUpdateRegularProduct(val, row, size) {
               if(val){
                    row.channelType=row.channelType+size;
                }else{
                    row.channelType=row.channelType-size;
                }
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateRegularProduct(row).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/sales/productrelevance.vue